jQuery(document).ready(function onAuthenticationReady($) {
    "use strict";

    $.ajaxSetup({
        xhrFields: {
            withCredentials: true
        }
    });

    var $login = $('.architect-login__login');
    var $register = $('.architect-login__register');
    var forms = {
        $login: $login.find('form'),
        $register: $register.find('form')
    };

    var loaders = {
        $login: $login.find('.architect-login__loading-wrapper'),
        $register: $register.find('.architect-login__loading-wrapper')
    };

    var submits = {
        $login: $login.find('input[type="submit"]'),
        $register: $register.find('input[type="submit"]')
    };

    var errors = {
        login: {
            $username: $login.find('.architect-login__error--username'),
            $password: $login.find('.architect-login__error--password'),
            $loginUnexpected: $login.find('.architect-login__error--login-unexpected'),
            $loginNotApproved: $login.find('.architect-login__error--login-not-approved'),
            $loginMissingCredentials: $login.find('.architect-login__error--missing-credentials'),
            $noMember: $login.find('.architect-login__error--no-member'),
            hideAllErrors: hideAllErrors.bind(null, 'login')
        },
        register: {
            $firstname: $register.find('.architect-login__error--firstname'),
            $lastname: $register.find('.architect-login__error--lastname'),
            $company: $register.find('.architect-login__error--company'),
            $email: $register.find('.architect-login__error--email'),
            $emailExists: $register.find('.architect-login__error--email-exists'),
            $password: $register.find('.architect-login__error--password'),
            $passwordConfirmEmpty: $register.find('.architect-login__error--password-confirm-empty'),
            $passwordConfirmMismatch: $register.find('.architect-login__error--password-confirm-mismatch'),
            $unexpectedError: $register.find('.architect-login__error--unexpected'),
            hideAllErrors: hideAllErrors.bind(null, 'register')
        }
    };

    var $thanks = $('.architect-login__thanks');

    forms.$login.on('submit', onLogin);
    //forms.$login.find('input[type="submit"]').on('click', onLogin);
    forms.$register.on('submit', onRegister);
    //forms.$register.find('input[type="submit"]').on('click', onRegister);

    $login.find('button').on('click', goTo.bind(null, 'register'));
    $register.find('button').on('click', goTo.bind(null, 'login'));
    $thanks.find('button').on('click', goTo.bind(null, 'login'));

    function onLogin(e) {
        e.preventDefault();
        errors.login.hideAllErrors();

        var url = forms.$login.attr('action');
        var username = forms.$login.find('input[name="username"]').val();
        var password = forms.$login.find('input[name="password"]').val();

        var error = false;
        if(username.length === 0) {
            errors.login.$username.show();
            error = true;
        }

        if(password.length === 0) {
            errors.login.$password.show();
            error = true;
        }

        if(error) {
            return;
        }

        submits.$login.hide();
        loaders.$login.show();

        $.ajax(url, {
            method: 'POST',
            url: forms.$login.attr('action'),
            data: forms.$login.serialize(),
            xhrFields: {
                withCredentials: true
            }
        })
            .done(onLoginDone)
            .fail(onLoginFail)
            .always(onLoginAlways);
    }

    function onLoginDone(response) {
        if(response.ok) {
            document.location.href = response.redirectUrl;
        } else {
            onLoginFail(response);
        }
    }

    function onLoginFail(response) {
        if(response.status === 'insufficient_credentials') {
            errors.login.$loginNotApproved.show();
        } else if(response.status === 'missing_credentials') {
            errors.login.$loginMissingCredentials.show();
        } else if(response.status === 'no_member') {
            errors.login.$noMember.show();
        } else {
            errors.login.$loginUnexpected.show();
        }
    }

    function onLoginAlways() {
        loaders.$login.hide();
        submits.$login.show();
    }

    function onRegister(e) {
        e.preventDefault();
        errors.register.hideAllErrors();

        var url = forms.$register.attr('action');
        var firstname = $register.find('input[name="firstname"]').val();
        var lastname = $register.find('input[name="lastname"]').val();
        var company = $register.find('input[name="company"]').val();
        var email = $register.find('input[name="email"]').val();
        var password = $register.find('input[name="password"]').val();
        var passwordConfirm = $register.find('input[name="password_confirm"]').val();

        var error = false;

        if(firstname.length === 0) {
            errors.register.$firstname.show();
            forms.$register.find('input[name="firstname"]').addClass('error');
            error = true;
        }

        if(lastname.length === 0) {
            errors.register.$lastname.show();
            forms.$register.find('input[name="lastname"]').addClass('error');
            error = true;
        }

        if(company.length === 0) {
            errors.register.$company.show();
            forms.$register.find('input[name="company"]').addClass('error');
            error = true;
        }

        if(email.length === 0) {
            errors.register.$email.show();
            forms.$register.find('input[name="email"]').addClass('error');
            error = true;
        }

        if(password.length === 0) {
            errors.register.$password.show();
            forms.$register.find('input[name="password"]').addClass('error');
            error = true;
        }

        if(passwordConfirm.length === 0) {
            errors.register.$passwordConfirmEmpty.show();
            forms.$register.find('input[name="password_confirm"]').addClass('error');
            error = true;
        }

        if(passwordConfirm !== password) {
            errors.register.$passwordConfirmMismatch.show();
            forms.$register.find('input[name="password_confirm"]').addClass('error');
            error = true;
        }

        if(error) {
            return;
        }

        submits.$register.hide();
        loaders.$register.show();

        $.ajax(url, {
            type: 'POST',
            data: {
                form: 'register',
                firstname: firstname,
                lastname: lastname,
                company: company,
                email: email,
                password: password,
                password_confirm: passwordConfirm
            },
            xhrFields: {
                withCredentials: true
            }
        })
            .done(onRegisterDone)
            .fail(onRegisterFail)
            .always(onRegisterAlways)
    }

    function onRegisterDone(response) {
        if(response.ok) {
            goTo('thanks');
        } else {
            onRegisterFail(response);
        }
    }

    function onRegisterFail(response) {
        if(response.status === 'password_mismatch') {
            errors.register.$passwordConfirmMismatch.show();
            forms.$register.find('input[name="password_confirm"]').addClass('error');
        } else if(response.status === 'empty_firstname') {
            errors.register.$firstname.show();
            forms.$register.find('input[name="firstname"]').addClass('error');
        } else if(response.status === 'empty_lastname') {
            errors.register.$lastname.show();
            forms.$register.find('input[name="lastname"]').addClass('error');
        } else if(response.status === 'empty_company') {
            errors.register.$company.show();
            forms.$register.find('input[name="company"]').addClass('error');
        } else if(response.status === 'empty_email') {
            errors.register.$email.show();
            forms.$register.find('input[name="email"]').addClass('error');
        } else if(response.status === 'empty_password') {
            errors.register.$password.show();
            forms.$register.find('input[name="password"]').addClass('error');
        } else if(response.status === 'empty_password_confirm') {
            errors.register.$passwordConfirmEmpty.show();
            forms.$register.find('input[name="password"]').addClass('error');
        } else if(response.status === 'email_exists') {
            errors.register.$emailExists.show();
            forms.$register.find('input[name="email"]').addClass('error');
        } else {
            errors.register.$unexpectedError.show();
        }
    }

    function onRegisterAlways() {
        loaders.$register.hide();
        submits.$register.show();
    }

    function goTo(mode) {
        switch(mode) {
            case 'login':
                $register.hide();
                $thanks.hide();
                $login.show();
                break;
            case 'register':
                $login.hide();
                $thanks.hide();
                $register.show();
                break;
            case 'thanks':
                $login.hide();
                $register.hide();
                $thanks.show();
                break;
        }
    }

    function hideAllErrors(mode) {
        forms['$' + mode].find('.error').removeClass('error');
        for(var key in errors[mode]) {
            if(!errors[mode].hasOwnProperty(key))
                continue;

            if(key.substr(0, 1) === '$') {
                errors[mode][key].hide();
            }
        }
    }
});
